import store from '@/stores/store';
import commonFn from '@/commons/commonFunction';

/**
 * Sync dữ liệu giữa các tab trên 1 trình duyệt
 * @param {*} eventId 
 * @param {*} handler 
 */
export const useSyncTabData = (eventId, handler) => {
  const syncTabId = commonFn.generateUUID();
  store.dispatch('context/syncTabId', syncTabId);

  const listenerHandler = (e) => {
    if (eventId === e.key) {
      if (e.newValue !== syncTabId) {
        handler(e.newValue);
      }
    }
  }
  window.addEventListener('storage', listenerHandler);
}